import CLoading from "components/CLoading";
import React, { Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrivateRoute from "router/PrivateRouter";
import RouterArr from "./router";
import { useSelector } from "react-redux";
import { RootState } from "../redux/rootReducers";

const MainRouter = (): JSX.Element => {
    const systemConfig = useSelector<RootState, any>(
        (state) => state.bootstrap.systemConfig
    );
    const basename = systemConfig.baseName;
    const isDebugMode = systemConfig.debug;

    return (
        <Router basename={basename}>
            <Suspense fallback={<CLoading visible={true} fullScreen={true} />}>
                <Switch>
                    {RouterArr.filter((r) => !r.isDebug || isDebugMode).map(
                        ({
                            path,
                            component,
                            isNotPrivate,
                            isDebug,
                            ...rest
                        }) => {
                            const results = isNotPrivate ? (
                                <Route
                                    path={path}
                                    component={component}
                                    key={path}
                                    {...rest}
                                />
                            ) : (
                                <PrivateRoute
                                    path={path}
                                    key={path}
                                    com={component}
                                    {...rest}
                                />
                            );
                            return results;
                        }
                    )}
                </Switch>
            </Suspense>
        </Router>
    );
};

export default MainRouter;
